import React from 'react';
import { formatText } from 'core/i18n';
import EditIcon from 'assets/icons/icon-edit-3-bold.svg';

export const EmailSummary = ({ email, handleClickModifyEmail }) => {
    return (
        <div className="otp__info">
            <p className="otp__info__text">{formatText('otpEmailValidation-justSentEmail')}</p>
            <div className="otp__info__email">
                <p className="otp__info__text--bold">{email}</p>
                <button className="otp__info__button" onClick={handleClickModifyEmail}>
                    <img src={EditIcon} alt="edit-icon" className="otp__info__edit-icon" />
                    {formatText('button-modify')}
                </button>
            </div>
        </div>
    );
};
